<template>
    <div>
        <div class="admin-filters elevation-1">
            <v-row>
                <v-col cols="12" sm="6" md="4" lg="2">
                    <v-text-field
                        v-model="filter.phone"
                        label="Телефон"
                        dense
                        outlined
                        hide-details
                        clearable
                    />
                </v-col>
                <v-col cols="12" sm="6" md="4" lg="2">
                    <v-text-field
                        v-model="filter.name"
                        label="Имя"
                        dense
                        outlined
                        hide-details
                        clearable
                    />
                </v-col>
                <v-col v-if="isAdmin" cols="12" sm="6" md="4" lg="2">
                    <v-select
                        v-model="filter.enabled"
                        label="Активен"
                        :items="booleanFilterItems"
                        dense
                        outlined
                        hide-details
                        clearable
                    />
                </v-col>
                <v-col v-if="isAdmin" cols="12" sm="6" md="4" lg="2">
                    <v-select
                        v-model="filter.admin"
                        label="Админ"
                        :items="booleanFilterItems"
                        dense
                        outlined
                        hide-details
                        clearable
                    />
                </v-col>
                <v-col v-if="isAdmin" cols="12" sm="6" md="4" lg="2">
                    <v-select
                        v-model="filter.partner"
                        label="Партнер"
                        :items="booleanFilterItems"
                        dense
                        outlined
                        hide-details
                        clearable
                    />
                </v-col>
                <v-col v-if="isAdmin" cols="12" sm="6" md="4" lg="2">
                    <v-select
                        v-model="filter.login_sms"
                        label="СМС при входе"
                        :items="booleanFilterItems"
                        dense
                        outlined
                        hide-details
                        clearable
                    />
                </v-col>
            </v-row>
            <v-row>
                <v-col>
                    <div class="admin-filters__actions">
                        <v-btn
                            color="primary"
                            @click="applyFilter"
                        >Применить</v-btn>
                        <v-btn
                            color="light"
                            @click="resetFilter"
                        >Сбросить</v-btn>
                    </div>
                </v-col>
            </v-row>
        </div>
        <v-data-table
            :headers="headers"
            :items="entities"
            class="elevation-1"
            disable-sort
            :loading="loading"
            :server-items-length="entitiesCount"
            :items-per-page="itemsPerPage"
            :footer-props="{ 'itemsPerPageOptions': [10, 15, 30] }"
            @pagination="paginate"
        >
            <template v-slot:top>
                <v-toolbar flat>
                    <v-toolbar-title>Пользователи</v-toolbar-title>
                    <v-spacer />
                    <v-btn color="primary" @click="create">
                        <v-icon>mdi-plus</v-icon> Добавить
                    </v-btn>
                </v-toolbar>
            </template>
            <template v-slot:[`item.name`]="{ item }">
                {{ item.firstname }} {{ item.lastname }}
            </template>
            <template v-slot:[`item.phone`]="{ item }">
                <span class="title">{{ item.phone }}</span>
            </template>
            <template v-slot:[`item.admin`]="{ item }">
                <span :class="`true-false-label ${getBadge(item.admin)}`">
                    &nbsp;{{item.admin ? 'Да' : 'Нет' }}&nbsp;
                </span>
            </template>
            <template v-slot:[`item.partner`]="{ item }">
                <span :class="`true-false-label ${getBadge(item.partner)}`">
                    &nbsp;{{item.partner ? 'Да' : 'Нет' }}&nbsp;
                </span>
            </template>
            <template v-slot:[`item.created_at`]="{ item }">
                {{ item.created_at | moment('DD.MM.YYYY HH:mm') }}
            </template>
            <template v-slot:[`item.enabled`]="{ item }">
                <span :class="`true-false-label ${getBadge(item.enabled)}`">
                    &nbsp;{{item.enabled ? 'Да' : 'Нет' }}&nbsp;
                </span>
            </template>
            <template v-slot:[`item.login_sms`]="{ item }">
                <span :class="`true-false-label ${getBadge(item.login_sms)}`">
                    &nbsp;{{ item.login_sms ? 'Да' : 'Нет' }}&nbsp;
                </span>
            </template>
            <template v-slot:[`item.open`]="{ item }">
                <a :href="`/users/${item.id}/detail`">
                    <v-icon color="primary">mdi-eye</v-icon>
                </a>
            </template>
        </v-data-table>
    </div>
</template>

<script>
    import store from '../../store';
    import { mapState } from 'vuex';

    const defaultFilter = () => ({
        phone: '',
        name: '',
        admin: null,
        partner: null,
        enabled: null,
        login_sms: null,
    });

    export default {
        name: 'UsersList',
        components: {
        },
        data: () => ({
            page: 1,
            itemsPerPage: 15,
            loading: true,
            filter: defaultFilter(),
            booleanFilterItems: [
                { text: 'Да', value: true },
                { text: 'Нет', value: false },
            ],
        }),
        computed: {
            ...mapState('users', ['entities', 'entitiesCount']),
            ...mapState('auth', ['user']),
            isAdmin() {
                return this.user.admin;
            },
            headers() {
                if(this.isAdmin) {
                    return [
                        { text: 'Дата', value: 'created_at' },
                        { text: 'Телефон', value: 'phone' },
                        { text: 'Админ', value: 'admin' },
                        { text: 'Партнер', value: 'partner' },
                        { text: 'Имя', value: 'name' },
                        { text: 'Активен', value: 'enabled' },
                        { text: 'СМС при входе', value: 'login_sms' },
                        { text: '', align: 'right', value: 'open' },
                    ]
                }
                return [
                    { text: 'Дата', value: 'created_at' },
                    { text: 'Телефон', value: 'phone' },
                    { text: 'Имя', value: 'name' },
                    { text: '', align: 'right', value: 'open' },
                ]
            }
        },
        async mounted() {
            await this.fetch();
        },
        methods: {
            async fetch() {
                this.loading = true;
                await store.dispatch('users/fetch', {
                    page: this.page,
                    itemsPerPage: this.itemsPerPage,
                    filter: this.filter,
                });
                this.loading = false;
            },
            async paginate({ page, itemsPerPage }) {
                this.page = page;
                this.itemsPerPage = itemsPerPage;
                await this.fetch();
            },
            applyFilter() {
                this.page = 1;
                this.fetch();
            },
            resetFilter() {
                this.filter = defaultFilter();
                this.page = 1;
                this.fetch();
            },
            getBadge (status) {
                return status ? 'success' : 'error';
            },
            async create() {
                await this.$router.push({ name: 'users-create' });
            },
            async open(id) {
                await this.$router.push({ name: 'users-detail', params: { id } });
            }
        }
    }
</script>

<style scoped>
    .title {
        font-size: 16px !important;
        line-height: 18px;
        font-weight: 700;
    }
</style>
